import api from "../../index";

export const GetMaintenanceStatusApi = () => api.post('/maintenance/status');
export const GetContactStatusApi = () => api.get('admin/turn-on/off-mobileno-ibtree-status');
export const TurnOnOffMobileNoOfIBTreeApi = (data) => api.patch('admin/turnonoff-mobileno-ibtree', data);
export const TurnOnfMaintenanceApi = () => api.post(`maintenance/enable`);
export const TurnOffMaintenanceApi = () => api.post(`maintenance/disable`);
export const UpdateParentDetaialsApi = (data) => api.post(`ibusermaster/update-parent-details-status`, data);

